<template>
    <form @submit.prevent="save" class="AddEditRecipe">

        <div v-if="Error" class="alert alert-danger" v-html="Error"></div>

        <div class="row">
            <div class="col-12 col-md-6">
                <fg-input label="Name" placeholder="Name" v-model:value="formInputs.name"></fg-input>
            </div>
            <div class="col-12 col-md-6">
                <fg-input label="Slug" placeholder="Slug" v-model:value="formInputs.slug"></fg-input>
            </div>
            <div class="col-12">
                <!-- ToDo: width: 768px the tags are extending outside the box -->
              <label>Tags</label>
              <Multiselect
                  v-model="formInputs.Tags"
                  mode="tags"
                  placeholder="Select your Tags"
                  :options="options"
                  noOptionsText="Create Tags by typing a tag name and hit enter. You can create/select multiple tags."
                  noResultsText="Looks like you are out of options. Create more. Once you are done typing the tag name, hit enter to create it."
                  :searchable="true"
                  @search-change="SearchTags"
                  :createTag="true"
                  @tag="CreateTag"
                  :appendNewTag="false"
                  :appendNewOption="false"
                  :key="'TagsKey'+NewOptionKey"
              />
            </div>
            <fieldset class="col-12 mb-2">
                <legend class="mb-0">Ingredients</legend>
                <div class="row">
                    <fg-input placeholder="Mesaurment" v-model:value="IngredientMeasurment" fgClasses="col-12 col-md-6 Measurment"></fg-input>
                    <MultiText :Inputs="Ingredients"
                        :LabelText="IngredientMeasurment"
                        :InputsLabels="IngredientsMeasurments"
                        placeholder="Ingredient"
                        @TextModified="ModifyIngredients"
                        divClasses="col-12 col-md-6 mb-0"
                        RecipeInsertClasses="col-8"
                    ></MultiText>
                </div>
            </fieldset>
            <div class="col-12">
                <MultiTextArea :Inputs="formInputs.steps" label="Steps" placeholder="Step" RecipeInsertClasses="col-8"></MultiTextArea>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <label>Image</label>
                <fg-input type="url" placeholder="Image URL" v-model:value="Image" addonRightIcon="FA-plus" :addonRightIconClick="AddImage"></fg-input>
                <img v-if="formInputs.image" :src="formInputs.image" alt="Image">
            </div>
            <div class="col-6">
                <label>Video</label>
                <fg-input type="url" placeholder="Video" v-model:value="Video" addonRightIcon="FA-plus" :addonRightIconClick="AddVideo"></fg-input>
                <iframe v-if="formInputs.video && formInputs.video.indexOf('youtube.com') > -1"
                    width="560" height="315" :src="formInputs.video"
                    style="border: 0"
                    ></iframe>
            </div>
        </div>

        <div class="row">
            <div class="col-12 text-center">
                <button class="btn btn-primary">{{ AddEdit }} Recipe{{ RecipeID ? ' #'+RecipeID : '' }}</button>
            </div>
        </div>

    </form>
</template>
<script>
import { format } from "date-fns";
import MultiText from "@/components/Inputs/MultiText";
import MultiTextArea from "@/components/Inputs/MultiTextArea";
import Multiselect from '@vueform/multiselect';
import { Notification } from "@/components";
import { useToast } from "vue-toastification";

import apiTags from '@/Modules/Tags/api/tags';
import apiRecipes from '@/Modules/Health/api/recipes';

let FormInputs = () => {
    return {
        name: '',
        slug: '',
        image: '',
        video: '',
        ingredients: [],
        steps: [],
        tags: [],
        Tags: []
    };
};

export default {
    components: {
        MultiText,
        MultiTextArea,
        Multiselect
    },
    data() {
        return {
            formInputs: FormInputs(),
            Ingredients: [],
            IngredientsMeasurments: [],
            IngredientMeasurment: '',
            Image: '',
            Video: '',
            Error: '',
            options: [],
            NewOptionKey: 0
        };
    },
    props: {
        Recipe: {
            type: Object,
            default: {}
        },
        InsertNew: {
            type: Boolean,
            default: true
        },
        FormInputsSet: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        AddEdit() {
            this.SetFormInputs();
            return this.InsertNew ? 'Insert New' : 'Update';
        },
        RecipeID() {
            return typeof this.Recipe.id !== 'undefined' ? this.Recipe.id : 0;
        },
        jsonIngredients() {
            let Ing = []; 
            for (let k in this.Ingredients)
            {
                Ing.push({Measurment: this.IngredientsMeasurments[k], Ingredient: this.Ingredients[k]});
            }
            return Ing;
        },
        UserID() {
            return this.$store.state.Users.id;
        },
        Tags() {
            return this.$store.getters.Tags_GetOptions();
        }
    },
    mounted() {
        this.$emit('SetFormInputs');

        apiTags.Index().then(res => {
            this.$store.dispatch('Tags_UpdateAll', res.data);
        });
    },
    methods: {
        UpdateImages(Images) {
            this.formInputs.image = Image;
        },
        SetFormInputs() {
            if (!this.FormInputsSet)
            {
                this.$emit('SetFormInputs');
                this.Error = '';
                this.formInputs = this.RecipeID ? {...(this.Recipe)} : FormInputs();
                this.Ingredients = [];
                this.IngredientsMeasurments = [];
                this.IngredientMeasurment = '';
                let Ingredients = [];
                if (this.formInputs.ingredients.length)
                {
                    this.formInputs.ingredients.forEach(Ing => {
                        Ingredients.push(Ing.Ingredient);
                        this.IngredientsMeasurments.push(Ing.Measurment);
                    });
                    this.Ingredients = Ingredients;
                }
                if (typeof this.formInputs.tags !== 'undefined') { this.formInputs.Tags = this.formInputs.tags.map(Tag => Tag.id); }
            }
        },
        save() {
            this.Error = '';
            if (this.InsertNew)
            {
                apiRecipes.Add(this.formInputs).then(res => {
                    this.$store.dispatch('Recipes_Add', res.data);
                    this.$emit('CloseRecipeModal');
                    this.formInputs = FormInputs();
                    this.NotifyUser('Recipe Added Successfully!', 'success');
                }).catch(e => {
                    this.processErrors(e.response.data.errors, e.response.status);
                });
            }
            else
            {
                apiRecipes.Update(this.Recipe.id, this.formInputs).then(res => {
                    this.$store.dispatch('Recipes_Update', res.data);
                    this.$emit('CloseRecipeModal');
                    this.formInputs = FormInputs();
                    this.NotifyUser('Recipe Updated Successfully!', 'success');
                }).catch(e => {
                    this.processErrors(e.response.data.errors, e.response.status);
                });
            }
        },
        processErrors(Errors, Status) {
            let i = 0;
            if (Status === 422)
            {
                for (let x in Errors)
                {
                    this.Error += (i?'<br>':'')+Errors[x].join('<br>');
                    this.NotifyUser(Errors[x], 'danger');
                    i++;
                }
            }
        },
        NotifyUser(text, type) {
            const toast = useToast();
            const icon = "now-ui-icons ui-1_bell-53";
            const content = {
                component: Notification,
                props: { icon, text, type },
            };
            // ToDo: The toast is popping up behind the modal
            toast(content, {
                hideProgressBar: true,
                icon: false,
                closeButton: false,
                position: 'top-right',
            });
        },
        SetIngredients() {
            this.formInputs.ingredients = [];
            for (let k in this.Ingredients)
            {
                this.formInputs.ingredients.push({Measurment: this.IngredientsMeasurments[k], Ingredient: this.Ingredients[k]});
            }
        },
        ModifyIngredients(Ingredients) {
            this.Ingredients = [];
            this.IngredientsMeasurments = [];
            for (let k in Ingredients.Labels)
            {
                this.IngredientsMeasurments.push(Ingredients.Labels[k]);
                this.Ingredients.push(Ingredients.Values[k]);
            }
            this.SetIngredients();
        },
        AddImage() {
            let Image = this.Image;
            if (Image.indexOf('https://drive.google.com/') === 0)
            {
                let aImage = Image.replace('https://drive.google.com/').split('/');
                Image = 'https://drive.google.com/uc?export=view&id='+aImage[aImage.length-2];
            }
            this.formInputs.image = Image;
            this.Image = '';
        },
        AddVideo() {
            // if (!this.Image.length) { return false; }
            let Video = this.Video;
            if (Video.indexOf('https://drive.google.com/') === 0)
            {
                let aVideo = Video.replace('https://drive.google.com/').split('/');
                Video = 'https://drive.google.com/uc?export=view&id='+aVideo[aVideo.length-2];
            }
            this.formInputs.video = Video;
            this.Video = '';
        },
        UpdateOptions() {
            this.options = this.$store.getters.Tags_GetOptions();
        },
        CreateTag(query) {
            apiTags.Add({users_id: this.UserID, title: query}).then(res => {
                let Tag = res.data;
                this.$store.dispatch('Tags_AddTag', Tag);
                this.GetNewTagIndex(query).then(index => {
                    this.UpdateOptions();
                    this.formInputs.Tags[index] = Tag.id;
                    this.NewOptionKey += 1;
                });
            });
        },
        GetNewTagIndex(query) {
            return new Promise(resolve => {
                setTimeout(() => {
                    let index = this.formInputs.Tags.indexOf(query);
                    resolve(index === -1 ? this.GetNewTagIndex(query) : index);
                }, 1);
            });
        },
        SearchTags(query, select) {
            console.log({query, select});
        }
    },
    watch: {
        Tags() {
            if (!this.NewOptionKey) {
                this.UpdateOptions();
                this.NewOptionKey += 1;
            }
        }
    }
};
</script>
<style lang="scss">
.AddEditRecipe {
    fieldset {
        border: 2px solid #DCDFE6;

        legend { width: auto; }
        >.row {
            .Measurment { margin-top: 30px; }
        }
    }
    .InsertRecipe { padding: 0; }
}
</style>
